import Box from "../Utils/Box.styled";
import Paragraph from "../Utils/Paragraph.styled";
import Stack from "../Utils/Stack.styled";
import Title from "../Utils/Title.styled";
const ErrorMessage = ({ title, message }) => {
  return (
    <Box padding="20px" radius="8px" minHeight="250px">
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap="32"
        height="250px"
      >
        {title && <Title size="30px">{title}</Title>}
        <Paragraph size="20px">{message}</Paragraph>
      </Stack>
    </Box>
  );
};

export default ErrorMessage;
